export default __webpack_public_path__ + "static/media/TwitterLogo.67344688.ico";